import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';

import { useFlags } from 'launchdarkly-react-client-sdk';

import { AccountSettings } from '../domains/account-settings/AccountSettings';
import { CommunicationCenter } from '../domains/CommunicationCenter/CommunicationCenter';
import { MainLayout } from './layout/MainLayout';
import { ManageDealer } from '../domains/manage-dealer/ManageDealer';
import { ProtectedRoute } from '../shared/components/ProtectedRoute';
import { PublicRoute } from '../shared/components/PublicRoute';
import Login from '../domains/login';
import Registration from '../domains/registration/Registration';
import SecurityPinManagement from '../domains/security-pin-management/SecurityPinManagement';
import VehicleManagement from '../domains/vehicle-management/VehicleManagement';

export const Routes: React.FC = () => {
  const { myvwFaRolloutCommunicationCenter } = useFlags();

  return (
    <MainLayout>
      <Switch>
        {/* Public route for login */}
        <Route exact path="/">
          <PublicRoute>
            <Login />
          </PublicRoute>
        </Route>

        {/* Protected routes */}
        <Route path="/manage-dealer">
          <ProtectedRoute>
            <ManageDealer />
          </ProtectedRoute>
        </Route>

        <Route path="/register">
          <ProtectedRoute>
            <Registration />
          </ProtectedRoute>
        </Route>

        <Route path="/account-settings">
          <ProtectedRoute>
            <AccountSettings />
          </ProtectedRoute>
        </Route>

        <Route path="/vehicle-management">
          <ProtectedRoute>
            <VehicleManagement />
          </ProtectedRoute>
        </Route>

        <Route path="/communication-center">
          {myvwFaRolloutCommunicationCenter ? (
            <ProtectedRoute>
              <CommunicationCenter />
            </ProtectedRoute>
          ) : (
            <Redirect to="/account-settings" />
          )}
        </Route>

        <Route path="/security-pin-management">
          <ProtectedRoute>
            <SecurityPinManagement />
          </ProtectedRoute>
        </Route>
      </Switch>
    </MainLayout>
  );
};
